import { MaterialGradeType, MaterialTypeType } from "../types";
import { areMaterialsEquals } from "./areMaterialsEquals";

type RawMaterialForDuplicateCheck = {
  id: string;
  type: MaterialTypeType;
  materialGrade: MaterialGradeType;
  name: string;
  height: number;
  width: number;
  length: number;
  tubeThickness: number | null;
};

type VolumetricMaterialForDuplicateCheck = {
  id: string;
  materialGrade: MaterialGradeType;
  name: string;
};

export const collectDuplicateIds = <T>(
  items: T[],
  areEqual: (a: T, b: T) => boolean,
  getId: (item: T) => string,
): string[] => {
  const duplicateIds = new Set<string>();

  for (let i = 0; i < items.length; i++) {
    for (let j = i + 1; j < items.length; j++) {
      if (areEqual(items[i]!, items[j]!)) {
        duplicateIds.add(getId(items[i]!));
        duplicateIds.add(getId(items[j]!));
      }
    }
  }

  return [...duplicateIds];
};

// Duplicate criteria for the "raw" material base: Format + Matière + Nuance matière + Dimensions
// all identical (price is not part of the criteria). See FAB-6201.
export const findDuplicateRawMaterialIds = (materials: RawMaterialForDuplicateCheck[]): string[] =>
  collectDuplicateIds(
    materials,
    (a, b) =>
      a.type === b.type &&
      a.height === b.height &&
      a.width === b.width &&
      a.length === b.length &&
      a.tubeThickness === b.tubeThickness &&
      areMaterialsEquals(a, b),
    (material) => material.id,
  );

// Duplicate criteria for the "volumetric" material base (real weight or capable rectangle):
// Matière + Nuance matière identical (price is not part of the criteria). See FAB-6201.
export const findDuplicateVolumetricMaterialIds = (
  materials: VolumetricMaterialForDuplicateCheck[],
): string[] => collectDuplicateIds(materials, areMaterialsEquals, (material) => material.id);
